import React, { createContext, useContext, useState, useCallback } from 'react';
import OfferWizard from '@/components/OfferWizard';

const OfferContext = createContext(null);

export const OfferProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefillService, setPrefillService] = useState('');

  const openOffer = useCallback((serviceSlug = '') => {
    setPrefillService(serviceSlug);
    setOpen(true);
  }, []);

  return (
    <OfferContext.Provider value={{ openOffer }}>
      {children}
      <OfferWizard open={open} onOpenChange={setOpen} prefillService={prefillService} />
    </OfferContext.Provider>
  );
};

export const useOffer = () => {
  const ctx = useContext(OfferContext);
  if (!ctx) throw new Error('useOffer must be used within OfferProvider');
  return ctx;
};
